import React, {useContext, useEffect, useState} from "react";
import "./StepFormStyles.scss";
import {Select} from "../../../components/inputs/Select";
import {MTPLTarifficationInputView} from "./Tariffication/InputView/MtplTarifficationInputView";
import {MTPLVehicleTypeSelectionView} from "./Tariffication/TypeSelection/MtplVehicleTypeSelectionView";
import {MTPLVehicleSearchView} from "./Tariffication/VehicleSearch/MtplVehicleSearchView";
import {
    findVehicleGroup,
    getConstructionYearOptions,
    mapVehicleFields,
    Vehicle,
    VehicleGroup,
    VehicleType
} from "../../../model/vehicle";
import {QuotationContext} from "../../../contexts/QuotationContext";
import {MtplQuotation} from "../../../model/quotation";
import {strings} from "../../../strings/strings";
import {InfoView} from "../../../components/InfoView/infoView";
import {PhoneAndDateBirthForms} from "./PhoneAndDateBirthForms";
import {selectedViewEnam} from "../../../model/pageEnam";
import {ScenarioContext} from "../../../contexts/ScenarioContext";
import {MTPLTarifficationDescription} from "./Tariffication/MtplTarifficationDescription";
import { useHotjar } from "../../../utils/hooks/useHotjar";

interface Props {
    onFormSubmit: () => void;
    setTextErrorMessageDialog: (string) => void;
    setOpenErrorMessageDialog: (bool) => void;
}

export const MTPLTarrifficationForm = ({onFormSubmit, setOpenErrorMessageDialog, setTextErrorMessageDialog}: Props) => {
    const {
        quotation,
        selectedView,
        setSelectedView,
        vehicleGroup,
        setVehicleGroup,
        vehicleFounded,
        setVehicleFounded,
        setQuotation,
        type,
        saveTempValues
    } = useContext<QuotationContext<MtplQuotation>>(QuotationContext);
    const { trackHotjar } = useHotjar()
    const {currentStep} = useContext(ScenarioContext);
    const [defaultVehicle, setDefaultVehicle] = useState<Vehicle>(quotation.mtplContract.vehicle);
    const [searchBy, setSearchBy] = useState<'phoneNumber' | 'plateNumber'>();


    useEffect(() => {
        let event = currentStep.code == 'greenCard_0001' ? 'green_card_shop_buy' : 'osago_shop_buy';
        console.log('Google Analytics Event = ' + event);
        // @ts-ignore
        window.dataLayer.push({'event': event});
    }, []);

    useEffect(() => {
        if( selectedView === selectedViewEnam.NEWCLIENT ){
            trackHotjar("", type )
        } else if (selectedView === selectedViewEnam.ARXCLIENT ){
            trackHotjar("login", type)
        }
    }, [selectedView])

    const resetVehicleFields = () => {
        const newQuotation = {...quotation};
        newQuotation.mtplContract.vehicle = {...defaultVehicle};
        setQuotation(newQuotation);
    };

    const emptyVehicleFields = () => {
        const newQuotation = {...quotation};
        newQuotation.mtplContract.vehicle = {
            id: null,
            vehicleType: null,
            brand: null,
            model: null,
            plateNumber: null,
            vin: null,
            constructionYear: null,
            engineType: null,
            batteryCapacity: null,
            colour: null,
            registerCity: null,
            ownerPartyType: "PERSON",
            ownerBirthYear: null,
            taxiUsage: null,
            requiredTO: null,
            nextToDate: null,
            engineCapacity: null,
            totalWeight: null,
            ownWeight: null,
            numberSeating: null,
        } as Vehicle;
        setDefaultVehicle(newQuotation.mtplContract.vehicle);
        setQuotation(newQuotation);
    };


    const onSearchListener = (vehicle: Vehicle) => {
        resetVehicleFields();
        const updatedVehicle = mapVehicleFields(vehicle, quotation.mtplContract.vehicle);

        if (vehicle.vehicleType) {
            const vehicleGroup = findVehicleGroup(vehicle.vehicleType);
            setVehicleGroup(vehicleGroup);
            saveTempValues('vehicleGroup', vehicleGroup)
        }

        setQuotation({
            ...quotation, 
            mtplContract: {
                ...quotation.mtplContract,
                vehicle: updatedVehicle
            }
        })
        setVehicleFounded(true);
    }

    return (
        <div className={'step-form'}>
            {selectedView !== selectedViewEnam.SECONDSEARCH &&
            <div className="step-form__toolbar">
                <div className="align-near">
                    <Select defaultValue={selectedView}
                            onValueSelect={setSelectedView}
                            items={[
                                {label: strings.toolbarSearchShort, id: 'toolbarNewClient', value: selectedViewEnam.NEWCLIENT},
                                {label: strings.toolbarManual, id: 'toolbarManual', value: selectedViewEnam.MANUAL}
                            ]}/>
                </div>
            </div>}

            {(selectedView === selectedViewEnam.NEWCLIENT || selectedView === selectedViewEnam.SECONDSEARCH) && !vehicleFounded && (
                <MTPLVehicleSearchView
                    onSearchListener={(vehicle) => {
                        setSearchBy("plateNumber");
                        onSearchListener(vehicle);
                    }} toManualInputListener={() => {
                    setSelectedView(selectedViewEnam.MANUAL);
                    const event = quotation.salesVariant === 'svs_05910264_package' ? '_SD_go_manual' : 'mtpl_go_manual'
                    console.log('Google Analytics Event = ' + event);
                    // @ts-ignore
                    window.dataLayer.push({'event': event});
                }}/>
            )}

            {(selectedView === selectedViewEnam.NEWCLIENT || selectedView === selectedViewEnam.SECONDSEARCH) && vehicleFounded && (
                <MTPLTarifficationInputView onSubmit={onFormSubmit}
                                            vehicleGroup={vehicleGroup}
                                            constructionYearLoadFunction={() => {
                                                return getConstructionYearOptions();
                                            }}
                                            searchBy={searchBy}
                                            onBackListener={() => {
                                                emptyVehicleFields();
                                                setVehicleGroup(undefined);
                                                saveTempValues('vehicleGroup', undefined)
                                                setVehicleFounded(false);
                                            }}/>
            )}

            {selectedView === selectedViewEnam.MANUAL && !vehicleGroup && (
                <MTPLVehicleTypeSelectionView onVehicleTypesSelect={(vehicleGroup: VehicleGroup) => {
                    setVehicleGroup(vehicleGroup);
                    saveTempValues('vehicleGroup', vehicleGroup)
                    trackHotjar(vehicleGroup, type)
                    if (vehicleGroup === VehicleGroup.B5) {
                        quotation.mtplContract.vehicle.vehicleType = VehicleType.B5;
                    }
                }}/>
            )}

            {selectedView === selectedViewEnam.MANUAL && vehicleGroup && (
                <MTPLTarifficationInputView onSubmit={onFormSubmit}
                                            constructionYearLoadFunction={() => {
                                                return getConstructionYearOptions();
                                            }}
                                            vehicleGroup={vehicleGroup}
                                            onBackListener={() => {
                                                resetVehicleFields();
                                                setVehicleGroup(undefined);
                                                setVehicleFounded(false);
                                            }}/>
            )}
            {selectedView === selectedViewEnam.ARXCLIENT && (
                <PhoneAndDateBirthForms setOpenErrorMessageDialog={setOpenErrorMessageDialog} setTextErrorMessageDialog={setTextErrorMessageDialog}
                    description={MTPLTarifficationDescription}/>
            )}
        </div>
    )

};